import { motion } from "framer-motion";
import { BellRing } from "lucide-react";
import { EASE } from "./Reveal";

const LINKS = [
  { id: "navbar-link-manifesto", label: "Manifiesto", href: "#manifiesto" },
  { id: "navbar-link-benefits", label: "Beneficios", href: "#beneficios" },
  { id: "navbar-link-how-it-works", label: "Cómo funciona", href: "#como-funciona" },
  { id: "navbar-link-pricing", label: "Precios", href: "#precios" },
  { id: "navbar-link-faq", label: "FAQ", href: "#faq" },
];

export const Navbar = () => (
  <motion.header
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 1, delay: 0.2, ease: EASE }}
    className="fixed inset-x-0 top-0 z-50"
  >
    <div
      data-testid="navbar-container"
      className="mx-4 mt-4 flex max-w-6xl items-center justify-between gap-4 rounded-2xl border border-white/10 bg-[#0A0A0C]/80 px-4 py-3 backdrop-blur-xl sm:px-6 lg:mx-auto"
    >
      <a href="#inicio" data-testid="navbar-logo" className="flex items-center gap-2.5">
        <span className="relative flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-500/15">
          <BellRing className="h-4 w-4 text-emerald-400" />
          <span className="pulse-dot absolute -right-1 -top-1 h-2 w-2 rounded-full bg-emerald-400" />
        </span>
        <span className="font-display text-lg font-bold tracking-tight">YateAviso</span>
      </a>

      <nav className="hidden items-center gap-7 lg:flex">
        {LINKS.map((l) => (
          <a
            key={l.id}
            data-testid={l.id}
            href={l.href}
            className="text-sm text-slate-400 transition-colors duration-300 hover:text-emerald-400"
          >
            {l.label}
          </a>
        ))}
      </nav>

      <div className="flex items-center gap-4">
        <span className="mono hidden text-[11px] uppercase tracking-widest text-slate-500 xl:block">
          <span className="text-emerald-400">+3,420</span> cobros recordados este mes
        </span>
        <a
          data-testid="navbar-cta-waitlist-button"
          href="#waitlist"
          className="rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 px-4 py-2 text-sm font-semibold text-[#0A0A0C] transition-transform duration-300 hover:scale-105 active:scale-95"
        >
          Acceso anticipado
        </a>
      </div>
    </div>
  </motion.header>
);
